/**
 * @generated SignedSource<<53310e3ebf6e69b825c80051419ab6b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TestsPreviewPanelCountersFragment$data = {
  readonly all: number | null | undefined;
  readonly ignored: number | null | undefined;
  readonly muted: number | null | undefined;
  readonly success: number | null | undefined;
  readonly " $fragmentType": "TestsPreviewPanelCountersFragment";
};
export type TestsPreviewPanelCountersFragment$key = {
  readonly " $data"?: TestsPreviewPanelCountersFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TestsPreviewPanelCountersFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TestsPreviewPanelCountersFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ignored",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "success",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "muted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "all",
      "storageKey": null
    }
  ],
  "type": "TestCounters",
  "abstractKey": null
};

(node as any).hash = "6f8906bf26fbc065a96748be28c35561";

export default node;
